export const EditBlue = (
  <svg
    width="46"
    height="39"
    viewBox="0 0 46 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.238281"
      y="0.664062"
      width="45.2365"
      height="38.1576"
      rx="5.30912"
      fill="#E8F0FF"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.8574 27.7422H29.8574C30.1226 27.7422 30.377 27.8475 30.5645 28.0351C30.7521 28.2226 30.8574 28.477 30.8574 28.7422C30.8574 29.0074 30.7521 29.2618 30.5645 29.4493C30.377 29.6368 30.1226 29.7422 29.8574 29.7422H15.8574C15.5922 29.7422 15.3379 29.6368 15.1503 29.4493C14.9628 29.2618 14.8574 29.0074 14.8574 28.7422C14.8574 28.477 14.9628 28.2226 15.1503 28.0351C15.3379 27.8475 15.5922 27.7422 15.8574 27.7422ZM14.8574 22.7422L24.8574 12.7422L27.8574 15.7422L17.8574 25.7422H14.8574V22.7422ZM25.8574 11.7422L27.8574 9.74219L30.8574 12.7422L28.8564 14.7432L25.8574 11.7422Z"
      fill="#1155CC"
    />
  </svg>
);
